module.exports = __webpack_public_path__ + "static/media/helpIcon2.9b314a85.png";